import { ReactComponent as CopyIcon } from 'assets/icons/design/copy.svg';

export const design = {
  copy: CopyIcon,
};
